import { useEffect, useState } from "react";
import { Printer, ArrowLeft } from "lucide-react";
import { api, rupiah } from "@/lib/api";
import { RekapTable } from "@/pages/RekapRT";
import { Kop } from "@/lib/kop";
import { usePejabat } from "@/context/PejabatContext";

export default function CetakRekap() {
  const [data, setData] = useState(null);
  const { pejabat: LURAH } = usePejabat();
  useEffect(() => {
    api.get("/stats").then((r) => setData(r.data));
  }, []);
  const today = new Date().toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
  const s = data?.summary;

  return (
    <div className="min-h-screen bg-slate-200 py-8 px-4" data-testid="cetak-page">
      <div className="no-print max-w-[1100px] mx-auto flex justify-between mb-4">
        <a href="/rekap" className="inline-flex items-center gap-2 text-sm text-slate-700" data-testid="cetak-back-link"><ArrowLeft className="h-4 w-4" /> Kembali</a>
        <button onClick={() => window.print()} className="inline-flex items-center gap-2 bg-[#0b4f4a] text-white text-sm rounded-lg px-4 py-2 hover:bg-[#072f2c]" data-testid="cetak-print-button">
          <Printer className="h-4 w-4" /> Cetak / Simpan PDF
        </button>
      </div>
      <div className="print-page max-w-[1100px] mx-auto bg-white shadow-lg p-10 text-slate-900">
        <Kop />
        <div className="text-center mt-5">
          <div className="font-bold underline">REKAPITULASI DATA PENDUDUK PER RT</div>
          <div className="text-sm">Keadaan per tanggal {today}</div>
        </div>
        {data && (
          <>
            <div className="mt-5 overflow-x-auto"><RekapTable data={data} /></div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm mt-5">
              <Sum k="Jumlah Penduduk" v={s.total} />
              <Sum k="Jumlah KK" v={s.kk} />
              <Sum k="KK Miskin" v={s.kk_miskin} />
              <Sum k="KK Tidak Mampu" v={s.kk_tidak_mampu} />
              <Sum k="Mutasi Lahir" v={data.mutasi.Lahir} />
              <Sum k="Mutasi Datang" v={data.mutasi.Datang} />
              <Sum k="Mutasi Meninggal" v={data.mutasi.Meninggal} />
              <Sum k="Mutasi Pindah" v={data.mutasi.Pindah} />
            </div>
            <p className="text-[11px] text-slate-600 mt-4">
              Keterangan: Bayi 0–11 bulan, Balita 1–4 th, Anak 5–14 th, Produktif 15–64 th, Lansia 65+ th. Status Miskin = pendapatan per kapita KK di bawah {rupiah(data.garis_kemiskinan)}/bulan; Tidak Mampu = di bawah 1,5× garis kemiskinan atau kepala keluarga bekerja di sektor rentan.
            </p>
          </>
        )}
        <div className="flex justify-end mt-12">
          <div className="text-center text-sm w-64">
            <div>Timika, {today}</div>
            <div className="font-semibold">{LURAH.jabatan}</div>
            {LURAH.ttd ? <img src={LURAH.ttd} alt="Tanda tangan" className="h-20 mx-auto object-contain" data-testid="rekap-ttd-image" /> : <div className="h-20" />}
            <div className="font-bold underline">{LURAH.nama}</div>
            <div>{LURAH.pangkat}</div>
            <div>NIP. {LURAH.nip}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Sum = ({ k, v }) => (
  <div className="border px-3 py-2 flex justify-between"><span>{k}</span><b>{Number(v || 0)}</b></div>
);
